module.exports = __webpack_public_path__ + "img/main_review_img_01.df4cc74a.png";